import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {format as stringFormat} from 'react-string-format';

import {URL_IMG} from '../../configs/urlConfigs';
import { MSG_REQUIRED,MSG_NOT_FOUND,MSG_CANCEL_REASONS_ADD_SUCCESS,MSG_CANCEL_REASONS_ADD_FAILED,MSG_CANCEL_REASONS_UPDATION_SUCCESS,MSG_CANCEL_REASONS_UPDATION_FAILED,MSG_CANCEL_REASONS_DELETION_SUCCESS,MSG_CANCEL_REASONS_DELETION_FAILED,MSG_CONFIRM_CANCEL_REASONS_DELETE,MSG_CANCEL_REASONS_DUPLICATE,MSG_CANCEL_REASONS_LOAD_FAILED} from '../../configs/msgConfigs';
import {LBL_ADD_NEW,LBL_APP_NAME,LBL_SETTINGS,LBL_EVENT_CANCEL_REASON,LBL_EVENT_CANCEL_REASONS,LBL_CONFIRM_DELETE,LBL_BACK_TO_SETTINGS} from '../../configs/labelConfigs'; 
import {ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,LOGIN_AFFILIATE_GROUP,LOGIN_SUPER_ADMIN_GROUP,ROUTE_SA_SETTINGS,ROUTE_AFFILIATE_SETTINGS} from '../../configs/staticConfigs';

import * as types from '../../actions';
import {clearAction} from '../../actions/commonActions';
import {cancelReasonsMasterListAction, cancelReasonsMasterAddAction, cancelReasonsMasterLoadAction, cancelReasonsMasterModifyAction, cancelReasonsMasterDeleteAction, cancelReasonsListAction, cancelReasonsAddAction, cancelReasonsLoadAction, cancelReasonsModifyAction, cancelReasonsDeleteAction} from '../../actions/cancelReasons';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

import {formValid} from '../../utils/validation';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

class CancelReasonsComponent extends Component { 

    constructor(props){
        super()

        this.state = {
            userGroup: 0,
            activeRowId:0,            
            formErrors:{
                cancelReason: MSG_REQUIRED,
            },          
            cancelReasonData:{
                cancelReasonId:'',
                cancelReason: null,                              
            },
            sortField:'name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }
        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);

        this.modal          = React.createRef(); 
        this.modalDelete    = React.createRef(); 
    }

    listItems = () => {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                this.props.cancelReasonsListAction();
            }
            else if(userGroup===LOGIN_SUPER_ADMIN_GROUP) {
                this.props.cancelReasonsMasterListAction();
            }
            this.setState({userGroup});
        } 
    }
  
    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.cancelReason = MSG_REQUIRED;
        this.setState({formErrors});
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{       
        this.setState({cancelReasonData:{
            cancelReasonId:'',
            cancelReason:null,
        }});              
    }

    onHandleChange = (event) =>{
        const {name, value} = event.target;

        let formErrors     = this.state.formErrors;
        let trimmedValue   = value.trim();
        switch(name){
            case 'cancelReason':
                formErrors.cancelReason = trimmedValue.length <=0 ? MSG_REQUIRED : ""; 
                break;            
            default :
            break;
        }

        let cancelReasonData   = this.state.cancelReasonData;
        cancelReasonData[name] = value;

        this.setState({formErrors,cancelReasonData});

    }

    onShowActionButtons = (event, rowId) =>{ 
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }    
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onSaveFormData = (id) =>{
        if(formValid(this.state)){
            let formErrors = this.state.formErrors;  
            if(this.state.cancelReasonData.cancelReason==null || this.state.cancelReasonData.cancelReason.trim().length < 1) { 
                formErrors.cancelReason = MSG_REQUIRED;
            }
            else {
                if(id){            
                    let cancelReasonData= {
                        id:id,
                        name: this.state.cancelReasonData.cancelReason,
                    } 
                    if(this.state.userGroup===LOGIN_AFFILIATE_GROUP){
                        this.props.cancelReasonsModifyAction(cancelReasonData);
                    }
                    else if(this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP) {
                        this.props.cancelReasonsMasterModifyAction(cancelReasonData);
                    }
                       
                }else{          
                    let cancelReasonData= {
                        name: this.state.cancelReasonData.cancelReason, 
                    } 
                    if(this.state.userGroup===LOGIN_AFFILIATE_GROUP){
                        this.props.cancelReasonsAddAction(cancelReasonData);
                    }
                    else if(this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP) {
                        this.props.cancelReasonsMasterAddAction(cancelReasonData);
                    }          
                }  
            }
            this.setState({formErrors}); 
        }else{
            let formErrors = this.state.formErrors;
            if(this.state.cancelReasonData.cancelReason==null || this.state.cancelReasonData.cancelReason.trim().length < 1){
                formErrors.cancelReason = MSG_REQUIRED;
            }            
            this.setState({formErrors});
        }
    }

    editBtnClick = (rowId) =>{  
        let formErrors = this.state.formErrors;
        formErrors.cancelReason = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal(); 
        if(this.state.userGroup===LOGIN_AFFILIATE_GROUP){
            this.props.cancelReasonsLoadAction({cancelReasonId:rowId});
        }
        else if(this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP) {
            this.props.cancelReasonsMasterLoadAction({cancelReasonId:rowId});
        }
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({
            cancelReasonData: {
                cancelReasonId: rowId,   
                cancelReason:name            
            }
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        if(this.state.userGroup===LOGIN_AFFILIATE_GROUP){
            this.props.cancelReasonsDeleteAction({id:this.state.cancelReasonData.cancelReasonId});
        }
        else if(this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP) {
            this.props.cancelReasonsMasterDeleteAction({id:this.state.cancelReasonData.cancelReasonId});
        }
        this.modalDelete.current.handleModelClose();              
    }

    onSort = (event,sortKey) =>{        
        // let sOrder = '';
        // if(this.state.sortField===sortKey){         
        //     sOrder = (this.state.sortOrder==='-') ? '' : '-';
        //     this.props.cancelReasonsListAction({column:sOrder+this.state.sortField});
        //     this.setState({ sortOrder:sOrder });            
        // }else{
        //     this.setState({ sortField:sortKey });
        //     this.props.cancelReasonsListAction({column:this.state.sortOrder+sortKey});
        // }        
    }    
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    } 

    setToasterState(isEnabled,message,isSucces,time=4000){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, time);
    }
  
    setStateUpdate(cancelReason,status,activity,errorData){
        let formErrors = this.state.formErrors;
        if(activity===types.CANCEL_REASONS_ADD_SUCCESS){           
            this.modal.current.handleModelClose();
            this.listItems(); 
            this.setToasterState(true,MSG_CANCEL_REASONS_ADD_SUCCESS,true); 
        }else if(activity===types.CANCEL_REASONS_ADD_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name') || errorData.hasOwnProperty('message')){
                    formErrors.cancelReason = MSG_REQUIRED; // errorData.name[0];  
                    this.setToasterState(true,stringFormat(MSG_CANCEL_REASONS_DUPLICATE," '"+this.state.cancelReasonData.cancelReason+"' "),false);             
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,MSG_CANCEL_REASONS_ADD_FAILED,false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                this.setToasterState(true,MSG_CANCEL_REASONS_ADD_FAILED,false);
                console.log(JSON.stringify(errorData));     
            }    
        }
        else if(activity===types.CANCEL_REASONS_LOAD_SUCCESS){ 
            this.setState({
                cancelReasonData:{
                    cancelReasonId:cancelReason.id,
                    cancelReason:cancelReason.name
                }
            }, () => {
                if(document.getElementById('cancelReason')) {
                    document.getElementById('cancelReason').focus(); 
                }
            });       
        }
        else if(activity===types.CANCEL_REASONS_LOAD_ERROR){ 
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_CANCEL_REASONS_LOAD_FAILED,false);
            console.log(JSON.stringify(errorData));   
        }
        else if(activity===types.CANCEL_REASONS_MODIFY_SUCCESS){            
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_CANCEL_REASONS_UPDATION_SUCCESS,true);       
            this.listItems(); 
        }else if(activity===types.CANCEL_REASONS_MODIFY_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name') || errorData.hasOwnProperty('message')){
                    formErrors.cancelReason = MSG_REQUIRED; // errorData.name[0];  
                    this.setToasterState(true,stringFormat(MSG_CANCEL_REASONS_DUPLICATE," '"+this.state.cancelReasonData.cancelReason+"' "),false);             
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,MSG_CANCEL_REASONS_UPDATION_FAILED,false);
                    console.log(JSON.stringify(errorData));
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                this.setToasterState(true,MSG_CANCEL_REASONS_UPDATION_FAILED,false);
                console.log(JSON.stringify(errorData));    
            }           
        }
        else if(activity===types.CANCEL_REASONS_DELETE_SUCCESS){      
            this.listItems(); 
            this.setToasterState(true,MSG_CANCEL_REASONS_DELETION_SUCCESS,true);
        }else if(activity===types.CANCEL_REASONS_DELETE_ERROR){
            this.setToasterState(true,MSG_CANCEL_REASONS_DELETION_FAILED,true);
        }
    }
    
    componentDidUpdate(prevProps) {  
        const {cancelReason,status,activity,errorData} = this.props;
        if (activity !== prevProps.activity) {
            this.setStateUpdate(cancelReason,status,activity,errorData);
            this.props.clearAction();
        }else{
        }        
    }

    componentDidMount() {     
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        // this.props.cancelReasonsListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});  
        this.setState({userGroup:userGroup});

        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_EVENT_CANCEL_REASONS;
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        this.listItems(); 
    }  

    render(){

        const {
            toastMessage,toastFlag,toastSuccess,cancelReasonData           
        } = this.state

        const { cancelReasonsItems,status,rowCount} = this.props;
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={userGroup===LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_SETTINGS : ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">                               
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table-other-exp" className="table" style={{width:"100%"}} >
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th >{LBL_EVENT_CANCEL_REASONS}</th>
                                        {/* onClick={(e) => this.onSort(e,'name')} className="sorting_asc" */}
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(rowCount===0) && 
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {(rowCount!==0) && cancelReasonsItems.map((item,index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.name}</td>
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>Edit</Link>
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>Delete</Link>
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {stringFormat(MSG_CONFIRM_CANCEL_REASONS_DELETE,"'"+cancelReasonData.cancelReason+"'")}
                </ModalWindow>


                <ModalWindow ref={this.modal} header={Number(this.state.cancelReasonData.cancelReasonId) > 0 ? "Edit "+LBL_EVENT_CANCEL_REASONS : "Add "+LBL_EVENT_CANCEL_REASONS} saveFormData={ (e)=>this.onSaveFormData(cancelReasonData.cancelReasonId)} resetModalForm={this.onModalFormReset} autoFocusField='cancelReason'>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{LBL_EVENT_CANCEL_REASONS}</label>
                                <div className="text-input">
                                <input className={this.state.formErrors.cancelReason.length >0 ? 'input-error' : ''} type="text" name="cancelReason" id="cancelReason" value={cancelReasonData.cancelReason || ''} onChange={this.onHandleChange} placeholder="" maxLength={120} />
                                    {this.state.formErrors.cancelReason.length >0 && this.state.formErrors.cancelReason!=MSG_REQUIRED && (
                                        <div className="text-red left-align text-12">{this.state.formErrors.cancelReason}</div>
                                    )} 
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalWindow>
            </div>
        )
        
    }
    
}
const mapStateToProps = (state) => {
    return {
        cancelReasonsItems : state.cancelReasons.items,
        cancelReason:state.cancelReasons.item,
        status:state.cancelReasons.status,
        activity:state.cancelReasons.activity,
        rowCount:state.cancelReasons.count,
        errorData:state.cancelReasons.errorData
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({

        cancelReasonsMasterListAction:cancelReasonsMasterListAction,  
        cancelReasonsMasterAddAction:cancelReasonsMasterAddAction,
        cancelReasonsMasterLoadAction:cancelReasonsMasterLoadAction,
        cancelReasonsMasterModifyAction:cancelReasonsMasterModifyAction,
        cancelReasonsMasterDeleteAction:cancelReasonsMasterDeleteAction,

        cancelReasonsListAction:cancelReasonsListAction,  
        cancelReasonsAddAction:cancelReasonsAddAction,
        cancelReasonsLoadAction:cancelReasonsLoadAction,
        cancelReasonsModifyAction:cancelReasonsModifyAction,
        cancelReasonsDeleteAction:cancelReasonsDeleteAction,

        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(CancelReasonsComponent);